module.exports = __webpack_public_path__ + "static/media/bolt.54e3ea5a.svg";